import { createContext, useContext, useEffect, useState } from "react";
import { faviconsBase64 } from "../faviconsBase64";

// Temas disponíveis
export const TEMAS = {
  DIXI: 'dixi',
  EVO: 'evo',
  TECNOPONTO: 'tecnoponto'
};

// Mapeamento de DNS para temas
const DNS_TEMA_MAP = {
  'dixi': TEMAS.DIXI,
  'localhost': TEMAS.DIXI, 
  'evo': TEMAS.EVO,
  'tecnoponto': TEMAS.TECNOPONTO,
};

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme deve ser usado dentro de um ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [temaAtual, setTemaAtual] = useState(TEMAS.DIXI);

  // Função para detectar o tema baseado na URL
  const detectarTemaPorURL = () => {
    try {
      const hostname = window.location.hostname;
      
      // Verifica correspondência parcial (contains) - prioridade para palavras-chave
      for (const [dns, tema] of Object.entries(DNS_TEMA_MAP)) {
        if (hostname.includes(dns)) {
          return tema;
        }
      }
      
      // Retorna tema padrão
      return TEMAS.DIXI;
    } catch (error) {
      console.error('Erro ao detectar tema por URL:', error);
      return TEMAS.DIXI;
    }
  };

  // Função para aplicar as classes CSS do tema no body
  const aplicarClasseTemaNoBody = (tema) => {
    document.body.classList.remove('theme-dixi', 'theme-evo', 'theme-tecnoponto');
    
    // Adiciona a classe do tema atual
    document.body.classList.add(`theme-${tema}`);
  };

  // Função para atualizar o favicon baseado no tema
  const atualizarFavicon = (tema) => {
    const link = document.getElementById("dynamic-favicon");
    if (!link) return;

    const faviconBase64 = faviconsBase64[tema];

    // fallback caso algo dê errado
    link.href = faviconBase64 || faviconsBase64.dixi;
  };

  // Função para atualizar o título da aplicação baseado no tema
  const atualizarTituloAplicacao = (tema) => {
    const titulos = {
      [TEMAS.DIXI]: 'Dixi Clientes',
      [TEMAS.EVO]: 'Evo Clientes', 
      [TEMAS.TECNOPONTO]: 'Tecnoponto Clientes'
    };
    
    document.title = titulos[tema] || 'Dixi Clientes';
  };

  // Inicializar tema baseado na URL
  useEffect(() => {
    const temaDetectado = detectarTemaPorURL();
    setTemaAtual(temaDetectado);
    // Aplicar favicon e título imediatamente na inicialização
    atualizarFavicon(temaDetectado);
    atualizarTituloAplicacao(temaDetectado);
  }, []);

  // Aplicar classe CSS, favicon e título quando o tema mudar
  useEffect(() => {
    aplicarClasseTemaNoBody(temaAtual);
    atualizarFavicon(temaAtual);
    atualizarTituloAplicacao(temaAtual);
  }, [temaAtual]);

  const contextValue = {
    temaAtual,
    detectarTemaPorURL,
    setTemaAtual, // Adicionar função para mudança manual
    TEMAS
  };

  return (
    <ThemeContext.Provider value={contextValue}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeContext;